import { merge, isEmpty } from "lodash";
import {
  lineToLinePaint,
  lineToLineLayout
} from "utilities/mapbox_style_adapters";
import { filterFeatureCollection } from "../../../utilities/geojson_adapters";
import generateId from "../../../utilities/random_id_generator";

export default class Line {
  defaultStyleOptions = {
    'layout': {
      'line-cap': 'round',
      'line-join': 'round'
    },
    'paint': {
      'line-color': '#ed6498',
      'line-width': 5,
      'line-opacity': 0.8
    }
  };

  constructor({ featureCollection, map, lineStyle }) {
    if (featureCollection.type != "FeatureCollection") throw "Must pass GeoJSON feature collection";

    const filteredFeatureCollection = filterFeatureCollection({
      featureCollection,
      types: ["LineString", "MultiLineString"]
    });
    if (isEmpty(filteredFeatureCollection.features)) {
      throw "Must pass LineString or MultiLineString as part of FeatureCollection";
    }

    this.id = generateId();
    this.featureCollection = filteredFeatureCollection;
    this.map = map;
    this.styleOptions = merge(
      this.defaultStyleOptions,
      lineToLineLayout(lineStyle || {}),
      lineToLinePaint(lineStyle || {})
    );

    this.map.addSource(this.sourceId(), {
      'type': 'geojson',
      'data': this.featureCollection
    });
  }

  isShowing() {
    return !!this.map.getLayer(this.layerId());
  }

  show() {
    if (this.isShowing()) return;

    this.map.addLayer({
      'id': this.layerId(),
      'type': 'line',
      'source': this.sourceId(),
      ...this.styleOptions
    });
  }

  hide() {
    if (this.isShowing()) {
      this.map.removeLayer(this.layerId());
    }
  }

  remove() {
    if (!this.map.getSource(this.sourceId())) return;

    this.map.removeSource(this.sourceId());
  }

  layerId() {
    return `line-layer-${this.id}`;
  }

  sourceId() {
    return `line-source-${this.id}`;
  }
}
